import { slugify } from "../../utils/slugify.js";
import type { Locale } from "../Locale.js";
import type { VoucherProduct } from "../VoucherProduct.js";

export function getVoucherPath(locale: Locale, { name }: Pick<VoucherProduct, "name">): string {
	return slugify(name[locale]);
}
